import { Body, LoadingIcon } from '@panwds/react-ui';
import React from 'react';
export function ResultsSummary({ selected, totalRecords, isBackgroundFetching = false, isLoading }) {
    if (isLoading) {
        return React.createElement("div", { style: { minHeight: '1rem' } });
    }
    return (React.createElement(Body, { as: "div", size: "sm", addClassName: "tw-flex tw-items-center tw-whitespace-nowrap" },
        React.createElement("div", { className: "dark:tw-text-gray-100" }, totalRecords === 0 ? ('0 results') : (React.createElement(React.Fragment, null, selected !== undefined && `${selected} ${selected !== 1 ? 'Rows' : 'Row'} Selected`))),
        isBackgroundFetching && React.createElement(LoadingIcon, { className: "tw-ml-4 tw-animate-spin" })));
}
//# sourceMappingURL=ResultsSummary.js.map